import AbstractProvider from '../services/App/AbstractProvider';
import {ILocalisation} from '../@interfaces/services/Localisation/ILocalisation';
import {LocalisationEvents} from '../@types/services/Localisation/Localisation';
import moment from 'moment/moment';

export class MomentJsProvider extends AbstractProvider {
	holdBootUntilNotCompleted = false;

	async boot() {
		this.getStoredService<ILocalisation>('trans')
			.listen(LocalisationEvents.SET_LOCALE, (e, payload) => {
				moment.locale(payload.newLocale as string);
			});
	}
}
